import { CatalogGrade } from "@/pages/steel/models/CatalogGrade";
import { Button, Grid2 as Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { useCatalogGradeContext } from "../CatalogGradeContext";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";

const useStyles = makeStyles(() => ({
	buttons: {
		opacity: 0,
		transition: "opacity 0.1s ease-in-out",
		".ag-row-hover &": {
			opacity: 1,
		},
		".ag-row-focus &": {
			opacity: 1,
		},
		".ag-row-selected &": {
			opacity: 1,
		},
	},
}));

type Props = {
	setSelectedRowData: (grade: CatalogGrade) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};
export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const { state } = useCatalogGradeContext();
	const classes = useStyles();
	const cellStyle = {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	};

	const rows: CatalogGrade[] =
		state.grades?.map((ladle: CatalogGrade) => ({
			...ladle,
		})) || [];

	const columnDefs: ColDef[] = [
		// Visible
		{
			field: "GradeName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
			cellStyle: cellStyle,
			sortable: true,
		},
		{
			field: "-",
			cellRenderer: (params: ICellRendererParams) => (
				<Grid
					container
					style={{
						height: "100%",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
					className={classes.buttons}
				>
					<Grid
						size={{ xs: 12 }}
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Button
							onClick={() => {
								(async () => {
									setSelectedRowData(params.data);
									setShowModal("update");
								})();
							}}
							title="Edit"
						>
							<EditIcon style={{ height: "auto" }} color="primary" />
						</Button>
						<Button
							onClick={() => {
								setSelectedRowData(params.data);
								setShowModal("delete");
							}}
							title="Delete"
						>
							<DeleteIcon style={{ height: "auto" }} color="error" />
						</Button>
						<Button
							onClick={() =>
								showContextMenu(event, params.data, "gradeContext")
							}
							title="Options"
						>
							<FormatListBulletedSharpIcon
								style={{ height: "auto" }}
								color="action"
							/>
						</Button>
					</Grid>
				</Grid>
			),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			sortable: false,
			flex: 1,
			maxWidth: 180,
			filter: false,
			autoHeaderHeight: true,
		},
	];
	return { rows, columnDefs };
};
